module.exports = __webpack_public_path__ + "media/customizations/regencyateverrange/logo-49ff6c441cfdeafad9d2757b2f320680.png";